/*
  a11y-fixes.js — doplnkova pristupnostni vylepseni (companion k minifikovanemu secondary.js).
  Pridava klavesnicovou ovladatelnost a ARIA stavy bez zasahu do vendor kodu.
  Nacita se z layout/theme.liquid (defer), bezi az po secondary.js.
*/
(function () {
  'use strict';

  /* ---------- Products mega-menu (#1) ----------
     Vendor trida ProductsMegaMenu (secondary.js) otevira menu a prepina sloupce jen na mouseover.
     Je to nativni <details>, takze Enter na <summary> ho otevre sam. Doplnujeme:
       - aria-expanded na <summary> (synchronizovane pres 'toggle' i pro mys),
       - prepnuti aktivniho sloupce pri fokusu hlavicky sloupce (ekvivalent mouseover -> displayContent),
       - Esc zavre menu a vrati fokus na <summary>.
  */
  function enhanceMegaMenu(menu) {
    var details = menu.querySelector('details[id^="ProductsMegaMenu-"]');
    var summary = menu.querySelector('summary.header__menu-item');
    if (!details || !summary) return;

    var list = menu.querySelector('.products-mega-menu__list');
    if (list && list.id) summary.setAttribute('aria-controls', list.id);
    summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');

    // 'toggle' se spusti pri kazde zmene open atributu (vc. setAttribute z vendor kodu) -> synchronizace pro mys i klavesnici
    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });

    // Fokus hlavicky sloupce zobrazi jeho obsah (neaktivni sloupce maji visibility:hidden, jinak by byly klavesnici nedostupne)
    menu.addEventListener('focusin', function (e) {
      var item = e.target.closest('[id^="ProductsMegaMenu-Item"]');
      if (!item) return;
      menu.querySelectorAll('[id^="ProductsMegaMenu-Item"]').forEach(function (i) {
        i.classList.remove('products-mega-menu__item--active');
      });
      item.classList.add('products-mega-menu__item--active');
    });

    // Esc zavre a vrati fokus na summary
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.hasAttribute('open')) {
        details.removeAttribute('open');
        summary.focus();
      }
    });
  }

  /* ---------- TNC / GDPR souhlasovy checkbox (#11) ----------
     Vendor <tnc-chekcbox> (secondary.js) reaguje jen na click a prepina data-checked; nema roli ani klavesnici.
     Doplnujeme role=checkbox, tabindex, aria-checked (synchronizace) a Space/Enter -> click (vendor toggle).
     Jmeno checkboxu se pocita z obsahu (text v <p>); ikony maji aria-hidden.
  */
  function enhanceTncCheckbox(el) {
    el.setAttribute('role', 'checkbox');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    function syncChecked() {
      el.setAttribute('aria-checked', el.dataset.checked === 'true' ? 'true' : 'false');
    }
    syncChecked();
    // listener je registrovan az po vendor handleru -> sync probehne po prepnuti data-checked
    el.addEventListener('click', syncChecked);
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        e.preventDefault();
        el.click();
      }
    });
  }

  /* ---------- Promo / newsletter popup (#13b) ----------
     Otevirani/zavirani resi remote main.js (prepina tridu popup-modal--active). Doplnujeme:
       - role=dialog, aria-modal, aria-labelledby (z nadpisu), tabindex pro fokus,
       - pri zobrazeni presun fokusu do dialogu + focus-trap (Tab cykli uvnitr), Esc zavre,
       - pri skryti navrat fokusu na puvodni prvek.
  */
  function enhancePopup(modal) {
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    if (modal.getAttribute('tabindex') === null) modal.setAttribute('tabindex', '-1');
    var title = modal.querySelector('.popup-modal__title, .popup-modal__heading');
    if (title) {
      if (!title.id) title.id = 'PopupTitle-' + Math.random().toString(36).slice(2, 8);
      modal.setAttribute('aria-labelledby', title.id);
    }

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var lastFocused = null;

    function focusables() {
      return Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE))
        .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
    }
    function onKeydown(e) {
      if (e.key === 'Escape') {
        var closeBtn = modal.querySelector('.popup-modal__close');
        if (closeBtn) closeBtn.click();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); modal.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function activate() {
      lastFocused = document.activeElement;
      modal.addEventListener('keydown', onKeydown);
      requestAnimationFrame(function () { modal.focus(); });
    }
    function deactivate() {
      modal.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }
    function sync() {
      var active = modal.classList.contains('popup-modal--active');
      if (active && !modal._a11yOpen) { modal._a11yOpen = true; activate(); }
      else if (!active && modal._a11yOpen) { modal._a11yOpen = false; deactivate(); }
    }
    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['class'] });
    sync(); // pro pripad, ze se popup renderuje rovnou aktivni (test mode)
  }

  /* ---------- Hlavickove dropdowny (#H-V1) ----------
     Nativni <details> hlasi stav castecne; doplnime explicitni aria-expanded na <summary> (sync pres toggle).
  */
  function enhanceDisclosureExpanded(details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary || summary.hasAttribute('aria-expanded')) return;
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('products-mega-menu').forEach(enhanceMegaMenu);
    document.querySelectorAll('tnc-chekcbox').forEach(enhanceTncCheckbox);
    document.querySelectorAll('.sign-up-popup-modal, .success-popup-modal').forEach(enhancePopup);
    document.querySelectorAll('header-menu details').forEach(enhanceDisclosureExpanded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
